import { QueryOptions, useQuery } from "react-query";
import { API_URL_V3, APIError, APIResponse, get } from "../api";

/* ----------------------------- TYPES ----------------------------- */
interface Institution {
  id: string;
  name: string;
  bank_code: string;
  type: string;
}

interface Customer {
  id: string;
  name: string;
  email: string;
}

export interface BankAccount {
  id: string;
  name: string;
  account_number: string;
  currency: string;
  balance: number;
  auth_method: string;
  status: string;
  bvn: string;
  type: string;
  institution: Institution;
  customer: Customer;
}

function useLinkedAccounts(
  options?: QueryOptions<APIResponse<BankAccount[]>, APIError>
) {
  const {
    isLoading: fetchingLinkedAccounts,
    isError,
    data: accounts,
    refetch,
  } = useQuery<APIResponse<BankAccount[]>, APIError>(
    "linked-accounts",
    () =>
      get(API_URL_V3 + "/mono/accounts", {
        byPassStatus: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    { refetchOnWindowFocus: true, refetchInterval: false, ...options }
  );

  return {
    fetchingLinkedAccounts,
    isError,
    accounts,
    refetch,
  };
}

export default useLinkedAccounts;
